import { OnInit, Renderer2, ElementRef, OnDestroy } from '@angular/core';
import { AttachmentService } from '../services/attachment.service';
var DynamicPropertyComponent = /** @class */ (function () {
    function DynamicPropertyComponent(renderer, elRef, attachmentService) {
        this.renderer = renderer;
        this.elRef = elRef;
        this.attachmentService = attachmentService;
    }
    DynamicPropertyComponent.prototype.ngOnInit = function () {
    };
    DynamicPropertyComponent.prototype.ngOnDestroy = function () {
        if (this.eventInstance) {
            this.eventInstance();
        }
    };
    Object.defineProperty(DynamicPropertyComponent.prototype, "setHTML", {
        set: function (html) {
            if (html.indexOf("{") > -1) {
                var re = new RegExp(/{(.*?)}/);
                var reString = re.exec(html);
                if (reString) {
                    if (reString.length > 0) {
                        this.type = reString[1].split(':')[0];
                        if (this.type) {
                            switch (this.type.toUpperCase()) {
                                case "FILE":
                                    var displayValue = reString[1].split(':')[1];
                                    this.fileId = reString[1].split(':')[2];
                                    this.htmlContent = html.replace(re, "<span class='listen-element'>" + displayValue + "</span>");
                                    break;
                                case "WORKFLOW":
                                    break;
                            }
                        }
                    }
                }
            }
            else {
                this.htmlContent = html;
            }
        },
        enumerable: true,
        configurable: true
    });
    DynamicPropertyComponent.prototype.afterInit = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.elRef.nativeElement.querySelector('.listen-element')) {
                if (_this.eventInstance) {
                    _this.eventInstance();
                }
                _this.eventInstance = _this.renderer.listen(_this.elRef.nativeElement.querySelector('.listen-element'), 'click', function () {
                    _this.downloadFixedFile();
                });
            }
        });
    };
    DynamicPropertyComponent.prototype.downloadFixedFile = function () {
        var _this = this;
        this.attachmentService.downloadFile(this.fileId).subscribe(function (data) {
            _this.attachmentService.getFileName(_this.fileId).subscribe(function (result) {
                var fileName = "file";
                fileName = result;
                _this.downloadFile(data, fileName);
            });
        });
    };
    DynamicPropertyComponent.prototype.downloadFile = function (blob, fileName) {
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);
    };
    return DynamicPropertyComponent;
}());
export { DynamicPropertyComponent };
